// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage, getQueryStrings } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    if (!props.needFullCart) {
        const expands = (props.apiParameter.expand || []).concat(["cartLines", "restrictions", "paymentOptions"]);
        props.apiParameter.expand = [...new Set(expands)] as typeof props.apiParameter.expand;
    }
    // XNG-Changes: CMI-700
    const state = props.getState();
    const pageType = getCurrentPage(state).type;
    const { cartId } = getQueryStrings(state);
    if (pageType === "OnePageCheckoutPage" && cartId) {
        props.apiParameter.cartId = cartId || API_URL_CURRENT_FRAGMENT;
    }
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
